module.exports = __webpack_public_path__ + "static/def1_rose-c8149899d5dbfa40248917bc92717be3.jpg";